import { Ng2StateDeclaration, StatesModule } from '@uirouter/angular';
import { FiBusinessAreaListState } from '@fi-app/business-area/states/business-area-list-state';
import { FiBusinessAreaAddState } from '@fi-app/business-area/states/business-area-add-state';
import { FiBusinessAreaViewState } from '@fi-app/business-area/states/business-area-view-state';
import { FiBusinessAreaEditState } from '@fi-app/business-area/states/business-area-edit-state';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiAbstractStateComponent } from '@fi-shared/fi-state-proxy/fi-abstract-state.component';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { AccessRightType, ApplicationSettingsType, ObjectTypes } from '@fi-shared/types';

const FiBusinessAreaState: Ng2StateDeclaration = {
    name: FiStateNames.BusinessArea._name,
    url: '/BusinessArea',
    abstract: true,
    parent: FiStateNames.GlobalSettings,
    component: FiAbstractStateComponent,
};

export const FiBusinessAreaStates: StatesModule = {
    states: [
        FiBusinessAreaState,
        FiBusinessAreaListState,
        FiBusinessAreaAddState,
        FiBusinessAreaViewState,
        FiBusinessAreaEditState,
    ],
};

export function registerBusinessAreaStateRules(stateAccessCheckService: StateAccessCheckService) {
    stateAccessCheckService.registerStateRules(
        [FiStateNames.BusinessArea.List, FiStateNames.BusinessArea.View, FiStateNames.BusinessArea.Edit],
        {
            SettingType: [ApplicationSettingsType.CoreGlobal],
            AccessType: AccessRightType.Admin,
        },
    );

    stateAccessCheckService.registerStateObjectType(
        [FiStateNames.BusinessArea.View, FiStateNames.BusinessArea.Edit],
        ObjectTypes.BusinessArea,
    );
}
